import getValidFolderPaneWidth from './helpers/getValidFolderPaneWidth';
import { initializeMailLayout } from '../actions/initializeMailLayout';
import { default as setFolderPaneWidth } from '../legacyActions/setFolderPaneWidth';
import setShowFolderPane from '../mutators/setShowFolderPaneMutator';
import LayoutChangeSource from '../store/schema/LayoutChangeSource';
import { getIsBitSet, ListViewBitFlagsMasks } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { orchestrator } from 'satcheljs';
import logFolderPaneState from '../helpers/logFolderPaneState';

export default orchestrator(initializeMailLayout, actionMessage => {
    /**
     * On init try to validate the folder pane width (NavigationBarWidth)
     */
    let storedFolderPaneWidth = getUserConfiguration().UserOptions.NavigationBarWidth;
    storedFolderPaneWidth = getValidFolderPaneWidth(storedFolderPaneWidth, LayoutChangeSource.Init);

    // Set folder pane width
    setFolderPaneWidth(storedFolderPaneWidth);

    const showFolderPane = !getIsBitSet(ListViewBitFlagsMasks.FolderPaneCollapsed);
    setShowFolderPane(showFolderPane);
    logFolderPaneState(LayoutChangeSource.Init, showFolderPane, showFolderPane);
});
